// Tiny shared toast: a bouncy little confirmation, used for "Copied!" and
// a couple of other one-off moments. Reduced-motion users still get the
// message — only the bounce is skipped (see .toast in style.css).

let toastEl: HTMLDivElement | null = null;
let hideTimer = 0;

export function showToast(text: string, ms = 1800): void {
  if (!toastEl) {
    toastEl = document.createElement('div');
    toastEl.className = 'toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastEl);
  }
  window.clearTimeout(hideTimer);
  toastEl.textContent = text;
  // Restart the animation even if already visible.
  toastEl.classList.remove('toast-show');
  void toastEl.offsetWidth;
  toastEl.classList.add('toast-show');
  hideTimer = window.setTimeout(() => toastEl?.classList.remove('toast-show'), ms);
}
